<template>
    <div fluid class="fill">
      <div v-if="!useModalView && !birthdayGroupModal">
        <div class="d-none d-md-block d-lg-block d-sm-none">
          <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
            <b-nav>
              <b-nav-item disabled>Action: </b-nav-item>
              <template v-if="selectedGroup != null || totalSelections > 0">
                <b-nav-item @click="handleDeleteGroup"><i class="icon-trash icons font-1xl"></i> Delete <span v-if="totalSelections > 1">({{totalSelections}})</span></b-nav-item>
                <b-nav-item v-if="totalSelections <= 1" @click="showEditBirthdayGroupModal"><i class="fa fa-edit"></i> Edit</b-nav-item>
              </template>
            </b-nav>
            <!-- Right aligned nav items -->
            <b-nav class="ml-auto">
              <b-button variant="primary" @click="showAddBirthdayGroupModal"><i class="cui-people icons d-block"> New</i></b-button>
            </b-nav>
          </b-navbar>
        </div>
        <b-row class="margin-0">
            <b-col lg="5" md="12" class="bg-light padding-0">
              <b-navbar toggleable="md" class="bottom-border padding-0" type="light" variant="white">
                <b-nav style="padding-top: 10px !important;">
                  <b-nav-item class="tab-button nav-item-black active"
                  ><i class="icon-list icons font-1xl d-sm-down-none"></i> Birthday Groups ({{groups.length}})</b-nav-item>
                </b-nav>
                <!-- Right aligned nav items -->
                <b-nav class="ml-auto">
                  <b-nav-item-dropdown text="Sort by" right>
                    <template slot="button-content">
                      <i class="py-0 fa fa-filter"></i> 
                      <em class="d-sm-down-none"> Filter </em>
                    </template>
                    <b-dropdown-item href="#">Name</b-dropdown-item>
                  </b-nav-item-dropdown>
                </b-nav>
              </b-navbar>
              <div class="border-0">
                  <div class="email-app border-0">
                      <main class="inbox border-0 padding-0">
                        <keep-alive>
                          <component
                              :is="birthdayGroupList"
                              :groups="groups"
                              @show-birthday-group-view="showBirthdayGroupView"
                              @show-birthday-group-selection="updateBirthdayGroupSelection"
                              @load-more-birthday-groups="handleLoadBirthdayGroups"
                          ></component>
                        </keep-alive>
                      </main>
                  </div>
              </div>
            </b-col>
            <b-col lg="7" md="0" class="pane-border d-md-down-none padding-0">
                <keep-alive v-if="!useModalView">
                <component
                    :is="birthdayGroupComponent"
                    :group="selectedGroup"
                    :totalSelections="totalSelections" 
                    :total="groups.length"
                    @all-birthday-group-selections="allBirthdayGroupSelections"
                    @delete-birthday-group-selections="deleteSelectedGroups"
                    @load-more-birthday-contacts="handleLoadContacts"
                    @load-more-birthday-messages="handleLoadMessages"
                    @birthday-group-edit="showEditBirthdayGroupModal"
                ></component>
              </keep-alive>
            </b-col>
        </b-row>
      <vue-fab
      class="d-sm-block d-md-none d-lg-none "
      :mainBtnColor="mainBtnColor"
      :icon="mainBtnIcon"
      @clickMainBtn="clickMainBtn">
        <fab-item 
            v-for="(item, idx) in menu"
            :idx="idx"
            :key="idx"
            :title="item.title"
            :color="item.color"
            :icon="item.icon"
            @clickItem="clickItem(item.link)"/>
      </vue-fab></div>
    <div v-else>
      <b-navbar toggleable="md" class="bottom-border" type="light" variant="light">
        <b-nav>
            <b-nav-item @click="useModalView = birthdayGroupModal = false"><i class="icon-arrow-left icons"></i></b-nav-item>
            <b-nav-item disabled> Back</b-nav-item>
            <!--b-nav-item><i class="cui-speech icons"></i> Free SMS</b-nav-item>
            <b-nav-item><i class="cui-comment-square icons"></i> Campaign SMS</b-nav-item-->
          </b-nav>
          <!-- Right aligned nav items -->
          <!--b-nav class="ml-auto">
            <b-nav-item><i class="icons icon-wallet"></i> Units Balance: {{Number(user.units_balance).toLocaleString()}}</b-nav-item>
          </b-nav-->
        </b-navbar>
          <!--keep-alive-->
            <component v-if="useModalView"
              :is="birthdayGroupComponent"
              :group="selectedGroup"
              :totalSelections="totalSelections" 
              :total="groups.length"
              @all-birthday-group-selections="allBirthdayGroupSelections"
              @delete-birthday-group-selections="deleteSelectedGroups"
              @load-more-birthday-contacts="handleLoadContacts"
              @load-more-birthday-messages="handleLoadMessages"
              @birthday-group-edit="showEditBirthdayGroupModal"
              :isDialog="false"
            ></component>
          <!--/keep-alive-->

        <VuePerfectScrollbar v-if="birthdayGroupModal" class="scroll-area" :settings="psSettings">
         <b-card class="m-2 mr-3">
            <p>{{modalTitle}}</p>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <input type="text" v-model="name" class="form-control" id="cc" placeholder="Enter name">
            </b-col>
          </div>
          <div class="form-row mb-3">
              <b-col cols="12" sm="12">
              <textarea class="form-control" id="description" v-model="description" rows="3" placeholder="Describe this birthday group"></textarea>
              </b-col>
          </div>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <v-select v-model="selectedTimeZone" :options="timeZones" placeholder="Select time zone"></v-select>
            </b-col>
          </div>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <datetime v-model="deliveryTime" format="HH:mm" value-zone="local" type="time"></datetime>
            </b-col>
          </div>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <v-select v-model="selectedTemplateGroup" :options="getTemplateGroups" placeholder="Select template group (optional)"></v-select>
              <small class="text-muted">Choose a template group if you want you birthday messages to be sending from template.</small>
            </b-col>
          </div>
          <div class="form-row mb-3">
            <b-col cols="11" sm="11">
              <v-select id="selectedNewsletterSub" v-model="selectedNewsletter" :options="newsletterOptions" placeholder="Select free SMS Newsletter"></v-select>
            <small class="text-danger">Note that you're the one to pay for the OTPs that will be sent to subscribers/prospects to verify their phone numbers. Do make sure your Zigatext account is well funded.</small>
            </b-col>
            <b-col class="col-1 col-sm-1 col-md-1">
              <div class="toolbar" role="toolbar"> 
                <div class="btn-group mr-1 pull-right">
                    <b-button variant="light" class="pull-right" @click="showSenderNameModal = true">
                      <span class="fa fa-plus"></span>
                    </b-button>
                </div>
              </div>
            </b-col>
          </div>
          <template v-if="user.user_type_id == globalVals.userTypeCorporate">
            <div class="form-row mb-3">
              <b-col cols="12" sm="12">
                <v-select v-model="selectedProject" :options="getProjects" placeholder="Select a project (optional)"></v-select>
                <small class="text-muted">Choosing a project from the list of your projects makes this birthday group accessible through API for you to add birthday contacts from third-party applications. If you don't have any project yet, you can create it on settings page under projects tab.</small>
              </b-col>
            </div>
          </template>

          <b-button class="mt-3" variant="primary" block @click="handleAction">

          <span v-if="!loading">{{actionText}}</span>
              <div class="sk-circle" v-if="loading">
                  <div class="sk-circle1 sk-child"></div>
                  <div class="sk-circle2 sk-child"></div>
                  <div class="sk-circle3 sk-child"></div>
                  <div class="sk-circle4 sk-child"></div>
                  <div class="sk-circle5 sk-child"></div>
                  <div class="sk-circle6 sk-child"></div>
                  <div class="sk-circle7 sk-child"></div>
                  <div class="sk-circle8 sk-child"></div>
                  <div class="sk-circle9 sk-child"></div>
                  <div class="sk-circle10 sk-child"></div>
                  <div class="sk-circle11 sk-child"></div>
                  <div class="sk-circle12 sk-child"></div>
              </div>
              <i v-if="flashSendError" class="fa fa-times"></i>
          </b-button>
        </b-card>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>

import Vue from "vue"
import vSelect from 'vue-select'
import { mapState, mapActions } from "vuex"
import { Datetime as datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import { timeZones } from '@/constants'
import birthdayGroupList from '@/components/birthdays/BirthdayGroupList'
import birthdayGroupView from '@/components/birthdays/BirthdayGroupView'
import {} from '@/services/notification.service'
import birthdayGroupAction from '@/components/birthdays/BirthdayGroupAction'
import {EventBus} from '@/events/bus.event'
import { globalVals } from '@/constants'
import router from '@/router/index'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'BirthdayMessenger',
  components: {
    birthdayGroupList,
    birthdayGroupView,
    vSelect,
    datetime,
    birthdayGroupAction,
    VuePerfectScrollbar,
  },
  data () {
    return {
      globalVals: globalVals,
      selectedProject: null,
      selectedTimeZone: null,
      selectedNewsletter:null,
      timeZones: timeZones,
      selectedTemplateGroup: null,
      deliveryTime: Vue.moment().format(),
      birthdayGroupModal: false,
      selectedGroup: null,
      birthdayGroupList: birthdayGroupList,
      birthdayGroupView: birthdayGroupView,
      birthdayGroupComponent: birthdayGroupAction,
      birthdayGroupAction: birthdayGroupAction,
      name: '',
      actionText: 'Create',
      modalTitle: 'Create birthday group',
      editing: false,
      description: '',
      flashSendError : false,
      useModalView: false,
      screenBreakPoint: 975,
      totalSelections: 0,
      menu: [],
      mainBtnColor: '#c2185b',
      mainBtnIcon: 'cui-people icons',
    }
  },
  computed: {
    ...mapState('birthday', ['groups', 'loading', 'nextPage', 'pages', 'serverResponse']),
    ...mapState('smsCollection', ['templateGroups']),
    ...mapState('user', ['user']),
    ...mapState('newsletter', ['newsletters', 'nextPage']),

    getProjects: function() {
        let projects = []
        for (let index in this.user.third_parties) {
            let project = { label: this.user.third_parties[index].project_name, value: this.user.third_parties[index].id }
            //if(this.user.profile.country_id == this.user.third_parties[index].id) {
                //this.selectedProject = project
            //}

            projects.push(project)
        }
        return projects
    },
    getTemplateGroups: function() {
        let templateGroups = []
        for (let index in this.templateGroups) {
          if (!this.templateGroups[index].approved || (this.templateGroups[index].personal && 
                                                          this.templateGroups[index].user_id != this.user.id))
            continue

          let templateGroup = { label: `${this.templateGroups[index].name} [${this.templateGroups[index].total_templates}]`, value: this.templateGroups[index].id }

          templateGroups.push(templateGroup)
        }
        return templateGroups
    },
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    },
    newsletterOptions() {
      let newsletterOptions = []
      this.newsletters.forEach(function (newsletter, key) {
        if(!newsletter.paid_sub)
          newsletterOptions.push({ value: newsletter.id, label: newsletter.name });
      })
      return newsletterOptions
    },
  },
  created() {
    if (this.groups.length <= 0) {
      this.fetchGroups({page:1})
    }

    if (this.templateGroups.length <= 0) {
      this.fetchSMSCollections({page:1})
    }
    
    if (this.newsletters.length <= 0) {
      this.fetchNewsletters({page:1})
    }
  },
  notifications: {
    showCreateSuccess: {
      title: 'Success',
      message: 'Your birthday group has been created!',
      type: 'success'
    },
    showCreateFailed: {
      title: 'Failed',
      message: 'Birthday Group could not be created at this time!',
      type: 'error'
    },
    showNotificationError: {
      title: 'Failed',
      message: 'You have not provided required field in form!',
      type: 'error'
    },
    showDeleteError: {
      title: 'Failed',
      message: 'There was error deleting these birthdays',
      type: 'error'
    },
    showDeleteSuccess: {
      title: 'Success',
      message: 'Birthday group(s) deleted successfully',
      type: 'success'
    },
    showUpdateSuccess: {
      title: 'Success',
      message: 'Birthday group updated!',
      type: 'success'
    },
    showUpdateFailed: {
      title: 'Failed',
      message: 'Birthday group could not be updated at this time!',
      type: 'error'
    },
  },

  methods: {
    ...mapActions('birthday', [
        'fetchGroups',
        'createGroup',
        'fetchGroupContacts',
        'deleteMultipleGroups',
        'deleteGroup',
        'fetchGroupMessages',
        'updateGroup',
    ]),
    ...mapActions('smsCollection', [
        'fetchSMSCollections'
    ]),
    
    ...mapActions('newsletter', [
        'fetchNewsletters',
    ]),

    handleLoadBirthdayGroups: function() {
      if(this.nextPage <= this.pages && !this.loading)
        this.fetchGroups({page:this.nextPage})
    },
    
    handleResize () {
      this.useModalView = window.innerWidth < this.screenBreakPoint
    },

    showBirthdayGroupView(e) {
      this.useModalView = window.innerWidth <= this.screenBreakPoint
      if(this.totalSelections > 0)
          return

      if(e.contacts.length === 0)
        this.fetchGroupContacts({groupId:e.id, page:e.contacts_next_page})

      if(e.messages.length === 0)
        this.fetchGroupMessages({groupId:e.id, page:e.messages_next_page})

      this.selectedGroup = e
      this.birthdayGroupComponent = this.birthdayGroupView
    },

    handleLoadContacts: function () {
      if(this.selectedGroup.contacts_next_page <= this.selectedGroup.contact_pages && !this.loading)
        this.fetchGroupContacts({groupId:this.selectedGroup.id, page:this.selectedGroup.contacts_next_page})
    },

    handleLoadMessages: function () {
      if(this.selectedGroup.messages_next_page <= this.selectedGroup.message_pages && !this.loading)
        this.fetchGroupMessages({groupId:this.selectedGroup.id, page:this.selectedGroup.messages_next_page})
    },

    showOnDialog () {
      return this.useModalView && this.totalSelections > 0
    },

    handleDeleteGroup() {
      if (this.loading) {
        this.$swal('You have already clicked delete button')
        return
      }

      this.$swal({
        title: "Delete birthday group",
        text: "Sure you want to delete this birthday group?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => { 
        if (result.value) {
          this.deleteSelectedGroups()
        }
      })
    },

    showAddBirthdayGroupModal: function() {
      this.name = ''
      this.description = ''
      this.selectedProject = null
      this.selectedTimeZone = null
      this.selectedNewsletter = null
      this.selectedTemplateGroup = null
      this.deliveryTime = Vue.moment().format()
      this.actionText = 'Create'
      this.modalTitle = 'Create birthday group'
      this.editing = false
      this.birthdayGroupModal = true
    },

    showEditBirthdayGroupModal: function() {
      this.name = this.selectedGroup.name
      this.description = this.selectedGroup.description
      this.selectedProject = null
      this.selectedTimeZone = null
      this.selectedTemplateGroup = null
      this.selectedNewsletter = null
      this.deliveryTime = this.formatTime(this.selectedGroup.delivery_time)

      for (let index in this.user.third_parties) {
        let project = { label: this.user.third_parties[index].project_name, value: this.user.third_parties[index].id }
        if(project.value == this.selectedGroup.third_party_id) {
            this.selectedProject = project
            break
        }
      }

      for(let i = 0; i < this.timeZones.length; i++) {
        if (this.timeZones[i].value == this.selectedGroup.time_zone_id) {
          this.selectedTimeZone = this.timeZones[i]
          break
        }
      }

      if(this.selectedGroup.newsletter_id > 0) {
        for (let index = 0; index < this.newsletters.length; index++) {
          if (this.selectedGroup.newsletter_id == this.newsletters[index].id) {
            this.selectedNewsletter = {value: this.newsletters[index].id, label: this.newsletters[index].name}
            break
          }            
        }
      }

      this.actionText = 'Update'
      this.modalTitle = 'Update birthday group'
      this.editing = true
      this.birthdayGroupModal = true
    },

    formatTime: function(date) {      
      return date.substr(11, 5)
    },

    async handleAction() {

      if(this.loading)
        return

      if(this.name == '' && this.description == '' && this.selectedTimeZone == null)  {
        this.showNotificationError()
        return
      }

      let timeZoneId = (this.selectedTimeZone != null) ? parseInt(this.selectedTimeZone.value) : 0
      let templateGroup = (this.selectedTemplateGroup != null) ? parseInt(this.selectedTemplateGroup.value) : 0

      const requestData = {
        "delivery_time"     : this.deliveryTime,
        "name"              : this.name,
        "time_zone_id"      : timeZoneId,
        "description"       : this.description,
        "template_id"       : templateGroup,
        "third_party_id"    : this.selectedProject != null ? parseInt(this.selectedProject.value) : 0,
        "newsletter_id"    : this.selectedNewsletter != null ? parseInt(this.selectedNewsletter.value) : 0,
      }
      
      if (this.editing) {
        let status = await this.updateGroup({ data: requestData, id: this.selectedGroup.id }) 
        if( !status ) {
          this.birthdayGroupModal = false
          this.showUpdateFailed({message: this.serverResponse.message})
        } else {
          this.birthdayGroupModal = false
          this.showUpdateSuccess()
        }
      } else {
        let status = await this.createGroup({ data: requestData})
        if( !status ) {
          this.actionText = ''
          this.flashSendError = true
          this.showCreateFailed({message: this.serverResponse.message})

          let interval = setInterval(() => {
            this.actionText = 'Create'
            this.flashSendError = false
            clearInterval(interval)
          }, 1000)
        } else {
          this.birthdayGroupModal = true
          this.showCreateSuccess()
        }
      }
    },

    allBirthdayGroupSelections: function (flag) {
      this.totalSelections = 0
      this.selectedGroup = null
      EventBus.$emit('birthday-group-selection-none')

      for (let i = 0; i < this.groups.length; i++) {
        this.groups[i].marked = flag
        flag && this.totalSelections++
        EventBus.$emit('birthday-group-selection-'+this.groups[i].id, flag)
      }
      this.birthdayGroupComponent = this.birthdayGroupAction
    },

    async deleteSelectedGroups() {
      let ids = []
      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].marked) {
          ids.push(this.groups[i].id)
        }
      }
      if(this.loading)
        return 

      let status = await this.deleteMultipleGroups({ids:ids})
      if( !status ) {
        this.showDeleteError({message: this.serverResponse.message})
      } else {
        this.showDeleteSuccess()
        this.allBirthdayGroupSelections(false)
      }
    },

    updateBirthdayGroupSelection: function (e, selected) {
      //this.useModalView = window.innerWidth <= this.screenBreakPoint
      selected ? this.totalSelections++ : this.totalSelections--

      if (this.totalSelections <= 0) {
        EventBus.$emit('birthday-group-selection-none')
        this.totalSelections = 0
        this.selectedGroup = null
      }

      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i].id === e.id) {
          this.groups[i].marked = selected
          break
        }
      }

      if (this.totalSelections > 0) {
        this.birthdayGroupComponent = this.birthdayGroupAction
      }
    },
    clickMainBtn: function () {
      this.showAddBirthdayGroupModal()
    }
  }
} 
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style type="text/css" scoped>
    .tab-content {
        border: 0 !important;
    }

  .sk-circle{
    margin: 0 auto 1px auto;
    width: 20px;
    height: 20px;
    position: relative;
    color: white !important;
  }

   @media (max-width: 768px) {
    .scroll-area {
      height: calc(100vh - 15.4vh);
    }
  }
</style>